import { render, staticRenderFns } from "./PromoEdit.vue?vue&type=template&id=624889d5"
import script from "./PromoEdit.vue?vue&type=script&lang=js"
export * from "./PromoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports